import React from "react";
import styles from "./ArticlesHead.module.css";
import Heading from "../../shared/Heading";

export default function ArticlesHead({ heading, image, bgColor }) {
  return (
    <>
      <section className={styles.hero_container} style={bgColor}>
        <div className={styles.main_container}>
          <div className={styles.flex_container}>
            <div className={styles.text_container}>
              <Heading level={1}>{heading}</Heading>
            </div>
            <div className={styles.image_column}>
              <img src={image} alt="" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
